export default (function () {
  const http = function (params) {
    params.url = process.env.API_LABCO + params.path
    params.data = JSON.stringify(params.data)
    params.contentType = 'application/json'
    params.headers = {
      Authorization: 'Bearer ' + sessionStorage.getItem('token')
    }
    if (params.blob) {
      params.xhrFields = {
        responseType: 'blob'
      }
    }
    const request = window.$.ajax(params)
    // Si 401, demande du login
    request.fail(function (xhr) {
      if (xhr.status === 401) {
        window.vm.$bvToast.toast(`Oups, vous n'êtes pas identifié`, {
          title: `Identification requise`,
          variant: 'warning',
          solid: true
        })
        setTimeout(() => {
          window.vm.$children[0].disconnect()
        }, 3000)
      }
      if (xhr.status === 403) {
        window.vm.$bvToast.toast(`Oups, vos droits sont insuffisants`, {
          title: `Droit insuffisants`,
          variant: 'warning',
          solid: true
        })
      }
    })
    return request
  }
  const api = {
    getAllResultatsByDate: function (numClient, dateDebut = null, dateFin = null, echantillonNum = null, page = 1, limite = 50, format = null) {
      return http({
        path: `/allResultatsByDate?numClient=${numClient}&page=${page}&limite=${limite}` +
          (echantillonNum != null ? `&echantillonNum=${echantillonNum}` : ``) +
          (dateDebut != null ? `&dateDebut=${dateDebut}` : ``) +
          (dateFin != null ? `&dateFin=${dateFin}` : ``) +
          (format != null ? `&format=${format}` : ``)
      })
    },
    getResultsByOneEchantillon: function (echantillonNum) {
      return http({
        path: `/resultsByOneEchantillon?echantillonNum=${echantillonNum}`
      })
    },
    getAllEchantillonsByDate: function (numClient, dateDebut = null, dateFin = null, echantillonNum = null, idProduct, page = 1, limite = 50, format = null) {
      return http({
        path: `/allEchantillonsByDate?numClient=${numClient}&page=${page}&limite=${limite}` +
              (echantillonNum != null ? `&echantillonNum=${echantillonNum}` : ``) +
              (idProduct != null ? `&idProduct=${idProduct}` : ``) +
              (dateDebut != null ? `&dateDebut=${dateDebut}` : ``) +
              (dateFin != null ? `&dateFin=${dateFin}` : ``) +
              (format != null ? `&format=${format}` : ``)
      })
    },
    getEchantillonsByAnalyseAndDate: function (numClient, idAnalyse, dateDebut = null, dateFin = null, echantillonNum = null, format = null) {
      return http({
        path: `/resultsByAnalyse?numClient=${numClient}&idAnalyse=${idAnalyse}` +
              (echantillonNum != null ? `&echantillonNum=${echantillonNum}` : ``) +
              (dateDebut != null ? `&dateDebut=${dateDebut}` : ``) +
              (dateFin != null ? `&dateFin=${dateFin}` : ``) +
              (format != null ? `&format=${format}` : ``)
      })
    },
    getEchantillonsByProductAndDate: function (numClient, idProduit, dateDebut = null, dateFin = null, echantillonNum = null, format = null) {
      return http({
        path: `/resultsByAnalyse?numClient=${numClient}&idProduit=${idProduit}` +
              (echantillonNum != null ? `&echantillonNum=${echantillonNum}` : ``) +
              (dateDebut != null ? `&dateDebut=${dateDebut}` : ``) +
              (dateFin != null ? `&dateFin=${dateFin}` : ``) +
              (format != null ? `&format=${format}` : ``)
      })
    },
    getAnalyseByDate: function (numClient, dateDebut = null, dateFin = null, echantillonNum = null) {
      return http({
        path: `/analysesByDate?numClient=${numClient}` +
              (echantillonNum != null ? `&echantillonNum=${echantillonNum}` : ``) +
              (dateDebut != null ? `&dateDebut=${dateDebut}` : ``) +
              (dateFin != null ? `&dateFin=${dateFin}` : ``)
      })
    },
    getProductByDate: function (numClient, dateDebut = null, dateFin = null, echantillonNum = null) {
      return http({
        path: `/productsByDate?numClient=${numClient}` +
              (echantillonNum != null ? `&echantillonNum=${echantillonNum}` : ``) +
              (dateDebut != null ? `&dateDebut=${dateDebut}` : ``) +
              (dateFin != null ? `&dateFin=${dateFin}` : ``)
      })
    },
    getProductsByClient: function (idClient) {
      return http({
        path: `/getProductsByClient?idClient=${idClient}`
      })
    },
    getSeriesAnalyses: function () {
      return http({
        path: `/series-analyses`
      })
    },
    getSeriesAnalysesSac: function (idClient, idFamily) {
      return http({
        path: `/series-analysesSac?idClient=${idClient}&idFamily=${idFamily}`
      })
    },
    getAllSacCustomers: function () {
      return http({
        path: `/getAllSacCustomers`
      })
    },
    getProductsGenerikByClient: function (idClient) {
      return http({
        path: `/getProductsGenerikByClient?idClient=${idClient}`
      })
    },
    getProductsGenerikByClientAndFam: function (idClient, idFamily) {
      return http({
        path: `/getProductsGenerikByClientAndFam?idClient=${idClient}&idFamily=${idFamily}`
      })
    },
    getFamilyByClient: function (idClient) {
      return http({
        path: `/getFamilyByClient?idClient=${idClient}`
      })
    },
    getLabcoCommentByFamily: function (idFamily) {
      return http({
        path: `/getLabcoCommentByFamily?idFamily=${idFamily}`
      })
    },
    getRefClient: function () {
      return http({
        path: `/ref-client`
      })
    },
    getRefFournisseur: function () {
      return http({
        path: `/ref-fournisseur`
      })
    },
    postEnregistrement: function (data) {
      return http({
        path: `/enregistrementProduit`,
        type: 'post',
        data: {data: data},
        async: false
      })
    },
    putEnregistrement: function (data) {
      return http({
        path: `/enregistrementProduit/${data.CENT_RECORD}/${data.CENT_NUM}`,
        type: 'put',
        data: data
      })
    },
    postAnalyse: function (data) {
      return http({
        path: `/enregistrementAnalyse`,
        type: 'post',
        data: data
      })
    },
    getAnalysesByClient: function () {
      return http({
        path: `/getAnalysesByClient`
      })
    },
    getNummRapportClient: function () {
      return http({
        path: `/getNumRapportsClientDay`
      })
    },
    getNummRapportClientByClient: function (idClient) {
      return http({
        path: `/getNumRapportsClientDay?idClient=${idClient}`
      })
    },
    getAnalyses: function () {
      return http({
        path: `/enregistrementAnalyse`
      })
    },
    getSyntheses: function () {
      return http({
        path: `/synthese-analyses`
      })
    },
    exportCSV: function (dateDebut, dateFin, anagNums) {
      let nums = ''
      anagNums.forEach((anag) => {
        nums += ('&anag_nums[]=' + anag.anag_num)
      })
      return http({
        path: `/export?&dateDebut=${dateDebut}&dateFin=${dateFin}` + nums
      })
    },
    getEnregistrementByClient: function (idClient, dateDebut, dateFin, select = 0, page = 1, limite = 50, format = null) {
      return http({
        path: `/getEnregistrementsByClient?idClient=${idClient}&dateDebut=${dateDebut}&dateFin=${dateFin}&select=${select}&page=${page}&limite=${limite}` +
              (format != null ? `&format=${format}` : ``)
      })
    },
    deleteEchantillon: function (dateRecord, echantillonNum) {
      return http({
        path: `/enregistrementProduit/${dateRecord}/${echantillonNum}`,
        type: 'delete'
      })
    },
    deleteEchantillonSac: function (dateRecord, echantillonNum, idClient) {
      return http({
        path: `/enregistrementProduit/${dateRecord}/${echantillonNum}/${idClient}`,
        type: 'delete'
      })
    }
  }
  return api
})()



// WEBPACK FOOTER //
// ./src/api.js